import { NAV_OBJECT_CREATE_COMPONENT, navObjectCreateDef } from 'navigation-components/config';
import { useComponentProps, useToggleComponent } from 'navigation-components/platform/hooks';
import { useCallback, useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from '../../hooks/useNavConfig';
import { ArrowContainer } from '../../nav-ui-components/ArrowContainer';
import PlusIcon from '../icons/PlusIcon';
import { ObjectCreateMenu } from './ObjectCreateMenu';
import { StyledMenuButton } from './StyledMenuButton';
import { arrowContainerStyles, arrowStyles, popoverContainerStyles } from './stylesheets';
import memoWithDisplayName from '../../utils/memoWithDisplayName';
import { useTheme } from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ObjectCreateButtonWrapper = styled.div.withConfig({
  displayName: "ObjectCreateButton__ObjectCreateButtonWrapper",
  componentId: "sc-1v18rky-0"
})(["display:flex;position:", ";"], ({
  $isMenuOpen
}) => $isMenuOpen ? 'static' : 'relative');
ObjectCreateButtonWrapper.displayName = 'ObjectCreateButtonWrapper';
export const ObjectCreateButton = memoWithDisplayName('ObjectCreateButton', () => {
  const theme = useTheme();
  const [isHovering, setIsHovering] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const {
    t
  } = useTranslation();
  const {
    toggle: toggleObjectBuilderNavComponent
  } = useToggleComponent(NAV_OBJECT_CREATE_COMPONENT);
  const objBuilderNavProps = useComponentProps(navObjectCreateDef);
  const toggleArrowContainer = useCallback(nextState => () => {
    if (nextState && isMenuOpen) return;
    setIsHovering(nextState);
  }, [isMenuOpen]);
  const onClick = useCallback(() => {
    setIsHovering(false);
  }, []);
  const onMenuItemClicked = useCallback(item => {
    // extractObjectType
    const objectId = item.id.replace(/^create/, '').toUpperCase();
    objBuilderNavProps({
      createObject: objectId
    });
    toggleObjectBuilderNavComponent(true);
    setIsMenuOpen(false);
  }, [objBuilderNavProps, toggleObjectBuilderNavComponent]);
  return /*#__PURE__*/_jsxs(ObjectCreateButtonWrapper, {
    "data-portal-hook": "object-create-menu",
    "data-test-id": "object-create-menu",
    $isMenuOpen: isMenuOpen,
    children: [/*#__PURE__*/_jsx(StyledMenuButton, {
      id: "hs-global-toolbar-object-create",
      "data-test-id": "hs-global-toolbar-object-create",
      "data-onboarding-hook": "object-create-menu-trigger",
      popoverContent: /*#__PURE__*/_jsx(ObjectCreateMenu, {
        onMenuItemClicked: onMenuItemClicked
      }),
      popoverPadding: 8,
      popoverContainerStyles: popoverContainerStyles(theme),
      popoverPortalHookId: "object-create-menu",
      popoverId: 'nav-object-create-menu',
      placement: 'bottom',
      onMouseEnter: toggleArrowContainer(true),
      onMouseLeave: toggleArrowContainer(false),
      onClick: onClick,
      dismissOnClickOutside: true,
      externalIsOpen: isMenuOpen,
      setExternalIsOpen: setIsMenuOpen,
      "aria-label": t('nav.icons.createNewObjectTooltip'),
      children: /*#__PURE__*/_jsx(PlusIcon, {})
    }), isHovering ? /*#__PURE__*/_jsx(ArrowContainer, {
      arrowPosition: "top",
      arrowSize: 8,
      containerStyles: arrowContainerStyles(theme),
      arrowStyles: arrowStyles(theme),
      "data-test-id": "hs-global-toolbar-object-create-tooltip",
      children: t('nav.icons.createNewObjectTooltip')
    }) : null]
  });
});